// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2687":"7a311807","3311":"e70cbd3a","3856":"c1238708"}[chunkId] + ".chunk.css";
};